


import React from 'react';
import { Link } from 'gatsby';
import Navbar from '../navbar_dd';
import NavbarHam from '../navbar';
import ReactGA from 'react-ga4';
import Consent from '../Consent';
import Helmet from 'react-helmet';
import './header.css';
import FlipBoard from '../FlipBoard.js';
import { courseNames } from '../../data/courseNames';

const primaryAnalyticsId = 'G-48ENESP49X';

const analyticsDestinations = [
  {
    trackingId: primaryAnalyticsId,
    gaOptions: {
      name: 'main-tracker',
      send_page_view: false,
    },
  },
  {
    trackingId: 'AW-856512071',
    gaOptions: {
      name: 'ads-tracker',
      send_page_view: false,
    },
  },
  {
    trackingId: 'UA-66109172-1',
    gaOptions: {
      name: 'ua-tracker',
      send_page_view: false,
    },
  },
];

const getPagePath = () => window.location.pathname + window.location.search;

const getPageTitle = () => {
  const normalizedPath =
    window.location.pathname === '/'
      ? '/'
      : `${window.location.pathname.replace(/\/+$/, '')}/`;

  return courseNames[normalizedPath] || document.title;
};

const sendPageView = () => {
  ReactGA.send({
    hitType: 'pageview',
    page: getPagePath(),
    title: getPageTitle(),
    send_to: primaryAnalyticsId,
  });
};

class Header extends React.Component {
  state = {
    slogan: 'Since 2015 / 500+ graduates',
  };

  lastTrackedPage = null;



  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('consent', 'default', {
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ad_storage: 'denied',
        analytics_storage: 'denied',
        wait_for_update: 500,
      });

      ReactGA.initialize(analyticsDestinations);
      this.lastTrackedPage = getPagePath();
      sendPageView();
    }
    // const slogans = [
    //   // 'Just coding, no nonsense / Est. 2015',
    //   // 'Upgrade yourself / Est. 2015',
    //   // 'Made by humans / Est. 2015',
    //   // 'JavaScript made me do it / Est. 2015',
    //   // 'Code is art / Est. 2015',
    //   // 'We pray to code / Est. 2015',
    // ];

    //   this.setState({
    //     slogan: slogans[Math.floor(Math.random() * slogans.length)],
    //   });
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined') {
      const currentPage = getPagePath();

      if (currentPage !== this.lastTrackedPage) {
        this.lastTrackedPage = currentPage;
        sendPageView();
      }
    }
  }

  allConsentGranted = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted',
      });
    }
  };

  render() {


    return (
      <span className="headerSpan">
        <Helmet script={[]} />

        <Navbar className="navbarDesktop" />
        <NavbarHam className="navbarHam" />

        <div
          className="transparentContainer"
          id="BCSname"
          style={{ background: 'rgb(255,255,255,80%)', width: '100%' }}
        >
          <h1 style={{ textAlign: 'left', fontSize: '3em' }} className="bcs">
            <Link to="/"><strong>Barcelona Code School</strong></Link>
          </h1>
          <h5 style={{ marginTop: '1em', marginBottom: '.5em' }}>{this.state.slogan}</h5>
        </div>

        <Consent allConsentGranted={this.allConsentGranted} />
      </span>
    );
  }
}

export default Header;
